import {
  FormNavigation,
  FormNavigationSection,
} from '~shared/ui/form-navigation';

import { PROFILE_NAV_STEPS, ProfileNavStepId } from '../lib/profile-nav-steps';

const PERSONAL_INFO_ITEMS = [
  { id: PROFILE_NAV_STEPS.basicInfo, label: 'Basic personal info' },
  { id: PROFILE_NAV_STEPS.address, label: 'Your address' },
  { id: PROFILE_NAV_STEPS.idDocument, label: 'Your ID' },
  { id: PROFILE_NAV_STEPS.selfie, label: 'Selfie' },
];

type ProfileFormNavigationProps = {
  activeStepId?: ProfileNavStepId;
};

export const ProfileFormNavigation = ({
  activeStepId,
}: ProfileFormNavigationProps) => {
  const isExpanded = activeStepId !== undefined;

  const sections: FormNavigationSection[] = [
    {
      id: 'personal-info',
      title: 'PERSONAL INFO',
      items: isExpanded
        ? PERSONAL_INFO_ITEMS.map((item) => ({
            ...item,
            isActive: item.id === activeStepId,
          }))
        : undefined,
    },
  ];

  return <FormNavigation sections={sections} />;
};
